<template>
  <div>
    <p class="mb-2 subtitle-2">
      {{ label }}
    </p>
    <v-menu
      v-model="menu"
      top
      nudge-bottom="105"
      nudge-left="16"
      :close-on-content-click="false"
    >
      <template #activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
        >
          <div
            v-if="value || isColor(defaultValue)"
            :style="swatchStyle"
          />
          <span
            v-if="value || defaultValue"
            class="pl-2"
          >
            {{ value || defaultValue }}
          </span>
          <v-icon right>
            mdi-chevron-down
          </v-icon>
        </v-btn>
      </template>
      <v-color-picker
        v-if="menu"
        ref="picker"
        v-model="internalValue.hex"
        mode="hexa"
        class="mx-auto"
        hide-mode-switch
        hide-canvas
        show-swatches
      />
      <div class="text-right white px-2 py-2">
        <v-btn
          color="grey"
          depressed
          text
          @click="clear"
        >
          {{ $t('Cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          depressed
          text
          @click="save"
        >
          {{ $t('Select color') }}
        </v-btn>
      </div>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: false,
      default: null
    },
    defaultValue: {
      type: String,
      required: false,
      default: null
    },
    label: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      menu: false,
      internalValue: {
        hex: this.value || this.defaultValue || '#ffffff'
      }
    }
  },

  computed: {
    swatchStyle() {
      return {
        backgroundColor: this.value || this.defaultValue,
        cursor: 'pointer',
        height: '20px',
        width: '20px',
        marginLeft: '-4px',
        marginRight: '0px',
        borderRadius: '4px',
        border: '1px solid #484848',
        transition: 'border-radius 200ms ease-in-out'
      }
    }
  },

  methods: {
    isColor(str) {
      return str.toString().match(/#[a-zA-Z0-9]{6}/);
    },

    save() {
      const val = this.$refs.picker.internalValue.hex;
      this.$emit('input', val);
      this.menu = false;
    },

    clear() {
      this.menu = false;
      this.internalValue.hex = this.defaultValue ? this.defaultValue : null;
      this.$emit('input', null);
    }
  }
}
</script>